// Lib
import { createAction } from '@reduxjs/toolkit';

export const SetSearchValue = createAction('SET_SEARCH_VALUE');
export const ClearSearchValue = createAction('CLEAR_SEARCH_VALUE');
